import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/img/myGuardianLinklogo.png';

import { adminRegisterApi } from '../api/auth.api';
import { apiHandler } from '../utils/apiHandler';

export default function Register() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: '',
  });

  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {

    function onKeyDown(e) {
      if (e.key === 'Enter') {
        handleRegister();
      }
    }

    document.addEventListener('keydown', onKeyDown);

    return () =>
      document.removeEventListener('keydown', onKeyDown);

  }, [formData]);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function handleRegister() {

    setError('');
    setSuccess(false);

    const {
      firstName,
      lastName,
      email,
      mobile,
      password,
      confirmPassword,
    } = formData;

    // Validation
    if (!firstName) {
      setError('Please enter first name');
      return;
    }

    if (!lastName) {
      setError('Please enter last name');
      return;
    }

    if (!email) {
      setError('Please enter email');
      return;
    }

    if (!password) {
      setError('Please enter password');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {

      setLoading(true);

      const result = await apiHandler(() =>
        adminRegisterApi({
          firstName,
          lastName,
          email,
          mobile,
          password,
        })
      );

      if (!result.success) {
        setError(result.message);
        return;
      }

      const responseData = result.data.data;

      // Save token
      localStorage.setItem(
        'adminToken',
        responseData.token
      );

      // Save admin data
      localStorage.setItem(
        'adminData',
        JSON.stringify(responseData.admin)
      );

      setSuccess(true);

      setTimeout(() => {
        navigate('/login');
      }, 1200);

    } catch (error) {

      setError('Registration failed');

    } finally {

      setLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--guardian-navy)',
        display: 'flex',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div className="bg-pattern" />
      <div className="shield-bg" />
      <div className="shield-bg" />
      <div className="shield-bg" />

      {/* LEFT SIDE */}
      <div className="login-left admin_login">

        <div className="brand-logo">
          <img src={logo} alt="myGuardianLink" />
        </div>

        <div className="divider-line" />

        <h1 className="hero-headline">
          Join the Future of <br />
          <span>Emergency Response.</span>
        </h1>

        <p className="hero-sub">
          Create your staff admin account to manage users,
          enrollments, emergency response systems, and
          organization-wide Guardian operations.
        </p>

        <div className="stat-row">

          <div className="stat-item">
            <div className="stat-num">24/7</div>
            <div className="stat-label">Monitoring</div>
          </div>

          <div className="stat-item">
            <div className="stat-num">99.9%</div>
            <div className="stat-label">System uptime</div>
          </div>

          <div className="stat-item">
            <div className="stat-num">18k+</div>
            <div className="stat-label">Protected users</div>
          </div>

        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="login-right admin_login">

        <div className="login-card">

          <div className="card-header">
            <div className="card-title">
              Staff Registration
            </div>

            <div className="card-sub">
              Create your Guardian Link admin account
            </div>
          </div>

          {/* ERROR */}
          {error && (
            <div className="alert-msg alert-error show">
              <i className="fas fa-circle-exclamation" />
              <span>{error}</span>
            </div>
          )}

          {/* SUCCESS */}
          {success && (
            <div className="alert-msg alert-success show">
              <i className="fas fa-circle-check" />
              <span>
                Registration successful! Redirecting...
              </span>
            </div>
          )}

          <div>

            {/* FIRST NAME */}
            <div className="form-group">
              <label className="form-label">
                First Name
              </label>

              <div className="input-wrap">
                <i className="fas fa-user" />

                <input
                  type="text"
                  name="firstName"
                  className="form-input"
                  placeholder="Enter first name"
                  value={formData.firstName}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* LAST NAME */}
            <div className="form-group">
              <label className="form-label">
                Last Name
              </label>

              <div className="input-wrap">
                <i className="fas fa-user" />

                <input
                  type="text"
                  name="lastName"
                  className="form-input"
                  placeholder="Enter last name"
                  value={formData.lastName}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* EMAIL */}
            <div className="form-group">
              <label className="form-label">
                Email Address
              </label>

              <div className="input-wrap">
                <i className="fas fa-envelope" />

                <input
                  type="email"
                  name="email"
                  className="form-input"
                  placeholder="admin@guardianlink.io"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* MOBILE */}
            <div className="form-group">
              <label className="form-label">
                Mobile Number
              </label>

              <div className="input-wrap">
                <i className="fas fa-phone" />

                <input
                  type="text"
                  name="mobile"
                  className="form-input"
                  placeholder="+91 9876543210"
                  value={formData.mobile}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* PASSWORD */}
            <div className="form-group">
              <label className="form-label">
                Password
              </label>

              <div className="input-wrap">
                <i className="fas fa-lock" />

                <input
                  type={showPass ? 'text' : 'password'}
                  name="password"
                  className="form-input form-input-right-icon"
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                />

                <button
                  className="input-right-btn"
                  type="button"
                  onClick={() =>
                    setShowPass((prev) => !prev)
                  }
                >
                  <i
                    className={`fas ${
                      showPass
                        ? 'fa-eye-slash'
                        : 'fa-eye'
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="form-group">
              <label className="form-label">
                Confirm Password
              </label>

              <div className="input-wrap">
                <i className="fas fa-lock" />

                <input
                  type={
                    showConfirmPass
                      ? 'text'
                      : 'password'
                  }
                  name="confirmPassword"
                  className="form-input form-input-right-icon"
                  placeholder="Confirm password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />

                <button
                  className="input-right-btn"
                  type="button"
                  onClick={() =>
                    setShowConfirmPass(
                      (prev) => !prev
                    )
                  }
                >
                  <i
                    className={`fas ${
                      showConfirmPass
                        ? 'fa-eye-slash'
                        : 'fa-eye'
                    }`}
                  />
                </button>
              </div>
            </div>

            {/* REGISTER BUTTON */}
            <button
              className="btn-login"
              onClick={handleRegister}
              disabled={loading}
              style={{
                opacity: loading ? 0.8 : 1,
              }}
            >

              {loading ? (
                <div
                  className="spinner"
                  style={{ display: 'block' }}
                />
              ) : (
                <i className="fas fa-user-shield" />
              )}

              <span>
                {loading
                  ? 'Creating Account...'
                  : 'Create Admin Account'}
              </span>
            </button>

            {/* LOGIN LINK */}
            <div
              style={{
                marginTop: 18,
                textAlign: 'center',
                fontSize: 14,
                color: '#94A3B8',
              }}
            >
              Already have an account?{' '}

              <span
                onClick={() => navigate('/login')}
                style={{
                  color: '#ec7426',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                Sign In
              </span>
            </div>

          </div>

          {/* FOOTER */}
          <div className="secure-badge">
            <i className="fas fa-shield-halved" />
            <span>
              Secured with 256-bit encryption · Staff access only
            </span>
          </div>

          <div className="card-footer">
            © 2026 myGuardianLink · Privacy Protected
          </div>

        </div>
      </div>
    </div>
  );
}